module.exports = __webpack_public_path__ + "img/bd(3).b403cd89.webp";